import { useEffect, useState } from "react";

const backend = process.env.REACT_APP_WS_URL;
export default function useCallSocket(businessNumber) {
  const [callEvent, setCallEvent] = useState(null);
  
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("userTokens"));
    const token = user?.access_token;
    const socketURL = `${backend}ws/calls/${businessNumber}/`;

    try {
      const ws = new WebSocket(socketURL);

      ws.onopen = () => {
        if (token) {
          ws.send(JSON.stringify({ type: "authentication", token }));
        }
      };
      ws.onmessage = ({ data }) => {
        try {
          const event = JSON.parse(data);
          setCallEvent(event);
        } catch (err) {
          console.error("Failed to parse WebSocket message:", err);
        }
      };
      return () => ws.close();
    } catch (err) {
      console.log("WebSocket error:", err);
    }
  }, [businessNumber]);
  
  return callEvent;
}